import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import { BrandFormContext } from 'context';
import type { Brand as BrandConfig, ComponentMode } from 'types';

import { BrandForm, BrandHeader } from './components';

type BrandProps = {
  mode: ComponentMode;
};

export default function Brand({ mode }: BrandProps) {
  const data = useLoaderData() as BrandConfig | undefined;

  const { title: brandTitle, bannerId } = data ?? {};
  const isUpdatedMode = mode === 'Update';

  const step = 1;
  const title = isUpdatedMode ? brandTitle : 'افزودن برند جدید';
  const defaultTitle = isUpdatedMode ? brandTitle : '';
  const bannerStatus = isUpdatedMode ? Boolean(bannerId) : false;

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${title} | کاشی لند`}</title>
      </Helmet>
      <BrandHeader>{title}</BrandHeader>
      <BrandFormContext
        mode={mode}
        step={step}
        defaultTitle={defaultTitle}
        bannerStatus={bannerStatus}
        ownerType='Brand'
        {...(isUpdatedMode ? data : {})}
      >
        <BrandForm />
      </BrandFormContext>
    </React.Fragment>
  );
}
